import { render, staticRenderFns } from "./LicenseUpgraded.vue?vue&type=template&id=6721bab8&scoped=true&"
import script from "./LicenseUpgraded.vue?vue&type=script&lang=js&"
export * from "./LicenseUpgraded.vue?vue&type=script&lang=js&"
import style0 from "./LicenseUpgraded.vue?vue&type=style&index=0&id=6721bab8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6721bab8",
  null
  
)

export default component.exports